import React, { useRef, useState } from 'react';
import './soundbar.css';
import music from "../../audio/V-Ray Showreel 2017.mp3";

export default function SoundBar({menuOpen}) {

    const ref = useRef(null);
    const [click, setClick] = useState(false);

    console.log("playing>>", click);

    const handleClick = () => {
        setClick(!click);

        if(!click){
            ref.current.play();
        }else{
            ref.current.pause();
        }
    }

    return (
        <div className={!menuOpen ? "fadesound" : "sound"}  onClick={() => handleClick()}>
            <span className={click && "play"} click={click}></span> 
            <span className={click && "play"} click={click}></span> 
            <span className={click && "play"} click={click}></span> 
            <span className={click && "play"} click={click}></span>  
            <audio src={music} ref={ref}  loop />
        </div>
    )
}
